import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const PreviewIcon = ({
  title = 'Preview',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 40 41" {...props}>
    {/* prettier-ignore */}
    <path fillRule="evenodd" clipRule="evenodd" d="M33.172 4.935L20.586 17.521l-.102.11a2 2 0 002.93 2.719L36 7.764v5.473l.005.15a2 2 0 003.995-.15v-10.3V.936H28l-.15.005A2 2 0 0026 2.936l.006.149A2 2 0 0028 4.935h5.172zM18 4.935a2 2 0 01.15 3.995l-.15.006H4v28h28v-14a2 2 0 011.85-1.995l.15-.005a2 2 0 011.995 1.85l.005.15v16a2 2 0 01-1.85 1.994l-.15.005H2a2 2 0 01-1.995-1.85L0 38.935v-32a2 2 0 011.85-1.994L2 4.936h16z" />
  </CreateIconComponent>
);

export default PreviewIcon;
